import Collection from 'lib/Collection';
import Subscription from 'entities/Subscription';

class Subscriptions extends Collection<Subscription> {
  initialize() {
    this.url = '/subscriptions';
    // @ts-ignore tsc doesnt like this way of initalizing model.
    this.model = Subscription;
  }

  getGroupIds() {
    return this.map(subscription => subscription.getGroupId());
  }
}

export default Subscriptions;
